import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiYpsiliLeft';
const args = {};

export class PetastiYpsiliLeft extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
